/* eslint-disable no-console */
import axios from '../../network/axios'
import { get } from '../../utilities'

import {
	LOGIN,
	LOGOUT,
	USER_SET_CURRENT,
	USER_REMOVE_CURRENT,
	USER_SUCCESS_STEP,
	USER_SET_TEMP,
	USER_REMOVE_TEMP,
	ACCOUNT_LIST
} from '../types'

// initial state
const state = {
	current: null,
	token: localStorage.getItem('token'),
	isLoggedIn: !!localStorage.getItem('token'),
	tempPassword: ''
}

const getters = {
	user: (state) => state.current,
	fullName: (state) => {
		return [
			get(state, 'current.first_name', ''),
			get(state, 'current.last_name', '')
		].join(' ')
	},
	firstName: (state) => {
		return get(state, 'current.first_name', '')
	},
	organization: (state, getters) => {
		return getters.organizations.map((item) => item.name).join(', ')
	},
	organizations: (state) => {
		return [...get(state, 'current.institutions', [])].sort((a, b) =>
			a.name > b.name ? 1 : -1
		)
	},
	group: (state) => get(state, 'current.group', null),
	cause: (state) => {
		var group = get(state, 'current.group', null)
		var org = get(state, 'current.institutions', [])
		if (group) {
			return {
				name: group.name,
				icon: group.icon,
				category: group.category,
				fact: group.fact,
				type: 'group',
				uuid: group.uuid
			}
		}
		if (org && org.length > 0) {
			org = org[0]
			return {
				type: 'org',
				uuid: org.uuid,
				username: org.username,
				name: org.name,
				icon: org.logo_url,
				category: org.category,
				fact: `Your change allows us to ${org.full_impact_statement}!`
			}
		}
		return null
	},
	isLoggedIn: (state) => state.isLoggedIn,
	hasUser: (state) => !!state.current,
	isDonating: (state) => state.current.is_donating,
	maxDonation: (state) => get(state, 'current.maximum_donation', null),
	minDonation: (state) => get(state, 'current.minimum_donation'),
	nextSignupStep: (state) => {
		if (!get(state, 'current.has_institution', false)) {
			return 'institutions'
		} else if (!get(state, 'current.minimum_donation', false)) {
			return 'mindonation'
		} else if (!get(state, 'current.has_valid_card', false)) {
			return 'card'
		} else if (!get(state, 'current.has_accounts', false)) {
			return 'pre-plaid'
		} else {
			return 'home'
		}
	},
	hasAccounts: (state) => get(state, 'current.has_accounts', false),
	hasCompletedSignup: (state) => {
		return get(state, 'current.has_completed_signup', false)
	},
	hasTOS: () => true,
	wholeDollar: () => get(state, 'current.whole_transaction_amount', 0),
	missingProfileInfo: (state) => {
		const user = state.current
		return !(user.first_name && user.last_name && user.phone && user.email)
	}
}

const actions = {
	login({ commit, dispatch }, creds) {
		return new Promise((resolve, reject) => {
			axios.post('/login', creds).then(
				({ data }) => {
					window.analytics.track('login', {
						email: creds.email,
						source: process.env.VUE_APP_TYPE
					})
					commit(USER_SET_CURRENT, data)
					commit(LOGIN, { token: data.token })
					dispatch('getCurrentUser')
					resolve()
				},
				({ response }) => {
					if (response.data) {
						reject(response.data)
					} else {
						reject(
							new Error(
								'Incorrect email or password combination. Please try again.'
							)
						)
					}
				}
			)
		})
	},

	loginWithToken({ commit, dispatch }, token) {
		return new Promise((resolve, reject) => {
			axios.post('/loginWithToken', { token }).then(
				({ data }) => {
					window.analytics.track('login_with_token', {
						email: data.email,
						source: process.env.VUE_APP_TYPE
					})
					commit(USER_SET_CURRENT, data)
					commit(LOGIN, { token: data.token })
					dispatch('getCurrentUser')
					resolve()
				},
				({ response }) => {
					if (response.data) {
						reject(response.data)
					} else {
						reject(
							new Error(
								'Incorrect email or password combination. Please try again.'
							)
						)
					}
				}
			)
		})
	},

	logout({ commit }) {
		window.analytics.track('logout', { source: process.env.VUE_APP_TYPE })
		return new Promise((resolve) => {
			commit(LOGOUT)
			resolve()
		})
	},

	getCurrentUser({ commit }) {
		return new Promise((resolve, reject) => {
			axios.get('/me').then(
				({ data }) => {
					commit(USER_SET_CURRENT, data)
					resolve()
				},
				({ response }) => {
					if (get(response, 'status', 200) === 401) {
						commit('LOGOUT')
					}
					reject(response)
				}
			)
		})
	},

	updateUser({ commit }, user) {
		return new Promise((resolve, reject) => {
			axios.put('/me', user).then(
				({ data }) => {
					window.analytics.track('update_user_info')
					commit(USER_SET_CURRENT, data)
					resolve()
				},
				({ response }) => {
					if (get(response, 'status', 200) === 401) {
						commit('LOGOUT')
					}
					reject(response.data)
				}
			)
		})
	},

	changePassword(_, passwords) {
		return new Promise((resolve, reject) => {
			axios.post('/me/changePassword', passwords).then(
				({ data }) => {
					window.analytics.track('user_change_password')
					resolve(data)
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},

	checkUserLoad({ state, dispatch }) {
		if (state.current) {
			return new Promise((resolve) => {
				resolve()
			})
		} else {
			return dispatch('getCurrentUser')
		}
	},

	register({ commit }, user) {
		const headers = {}
		if (!user.first_name && !user.last_name && !user.phone) {
			headers['register-by'] = 'email_only'
		}
		return new Promise((resolve, reject) => {
			axios.post('/register', user, { headers }).then(
				({ data }) => {
					window.analytics.track('user_sign_up', {
						source: process.env.type
					})
					commit(USER_SET_CURRENT, data)
					commit(LOGIN, { token: data.token })
					resolve(data)
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},

	forgotPassword(context, email) {
		return new Promise((resolve, reject) => {
			axios.post('/password/forgot', { email: email }).then(
				({ data }) => {
					window.analytics.track('user_forgot_password')
					resolve(data)
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},

	resetPassword({ commit }, creds) {
		return new Promise((resolve, reject) => {
			axios.post('/password/reset', creds).then(
				({ data }) => {
					window.analytics.track('user_set_password')
					commit(USER_SET_CURRENT, data)
					resolve(data)
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},

	closeAccount({ commit }) {
		return new Promise((resolve, reject) => {
			axios.delete('/me').then(
				() => {
					window.analytics.track('user_close_account')
					commit(LOGOUT)
					resolve()
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},

	fetchLinkToken() {
		const body = {}
		if (process.env.VUE_APP_TYPE === 'android') {
			body.redirectUri = 'https://roundup.app/RedirectToApp/Accounts'
		}
		return new Promise((resolve, reject) => {
			axios
				.post('/me/plaidToken', body)
				.then(({ data }) => resolve(data))
				.catch((err) => reject(err))
		})
	},
	attachLink({ commit, dispatch }, params) {
		return new Promise((resolve, reject) => {
			axios.post('/me/bank', params).then(
				({ data }) => {
					window.analytics.track('user_link_bank')
					dispatch('getLinks')
					commit(ACCOUNT_LIST, data)
					commit(USER_SUCCESS_STEP, 'has_accounts')
					resolve(data)
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},

	attachCard({ dispatch, commit }, { token, amount }) {
		return new Promise((resolve, reject) => {
			axios.post('/me/card', { public_token: token, amount }).then(
				({ data }) => {
					window.analytics.track('user_link_funding_source')
					commit(USER_SUCCESS_STEP, 'has_valid_card')
					dispatch('getCurrentUser')
					resolve(data)
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},

	attachInstitution({ commit, dispatch }, institution) {
		return new Promise((resolve, reject) => {
			axios
				.post('/me/institution', { institution_id: institution.id })
				.then(
					({ data }) => {
						window.analytics.track('user_select_cause', {
							institution_id: institution.id
						})
						commit(USER_SUCCESS_STEP, 'has_institution')
						dispatch('getCurrentUser')
						resolve(data)
					},
					({ response }) => {
						reject(response.data)
					}
				)
		})
	},

	finishSignup({ commit }) {
		return new Promise((resolve, reject) => {
			axios.post('/me/finishSignup').then(
				({ data }) => {
					window.analytics.track('user_complete_sign_up')
					commit(USER_SUCCESS_STEP, 'has_completed_signup')
					resolve(data)
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},

	setMultiplier({ commit }, multiplier) {
		return new Promise((resolve, reject) => {
			axios.post('/me/multiplier', { multiplier }).then(
				({ data }) => {
					window.analytics.track('user_set_multiplier', {
						multiplier
					})
					commit(USER_SET_CURRENT, data)
					resolve()
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},
	acceptTOS({ commit }) {
		return new Promise((resolve, reject) => {
			axios.put('/me/acceptTOS').then(
				(data) => {
					window.analytics.track('user_accepted_TOS')
					commit(USER_SET_CURRENT, data)
					resolve()
				},
				({ response }) => {
					reject(response.data)
				}
			)
		})
	},
	donateNow({ dispatch }, amount) {
		return new Promise((resolve, reject) => {
			axios.put('/donate/oneTime/' + amount).then(
				() => {
					window.analytics.track('one_time_donation', { amount })
					dispatch('getHome')
					resolve()
				},
				({ response }) => {
					dispatch('getHome')
					reject(response.data)
				}
			)
		})
	}
}

// mutations
const mutations = {
	[LOGIN](state, tokens) {
		state.isLoggedIn = true
		state.token = tokens.token

		// Store token as well as set it for axios use
		localStorage.setItem('token', tokens.token)
	},

	[LOGOUT](state) {
		state.isLoggedIn = false
		state.token = null
		state.current = null

		// Remove local store
		localStorage.removeItem('token')
	},
	[USER_SET_CURRENT](state, user) {
		state.current = user
	},
	[USER_REMOVE_CURRENT](state) {
		state.current = null
	},
	[USER_SUCCESS_STEP](state, step) {
		state.current[step] = true
	},
	[USER_SET_TEMP](state, temp) {
		state.tempPassword = temp
	},
	[USER_REMOVE_TEMP](state) {
		state.tempPassword = ''
	}
}

export default {
	state,
	getters,
	mutations,
	actions
}
